import ErrorPage from "../pages/ErrorPage/ErrorPage";

export const DefaultPublicRoutes = [
    {
        path: '/*',
        exact: false,
        component: ErrorPage
    },
];
